module.exports = __webpack_public_path__ + "img/6.4e29ba05.png";